import { z } from 'zod';

export const GenderSchema = z.object({
  idGender: z.number().int(),
  Gender: z.string(),
});

export type IGender = z.infer<typeof GenderSchema>;
